import React, { EventHandler } from 'react';
import { Editor as Ed } from '@tinymce/tinymce-react';

interface IEditorProps {
  initialValue: string,
  onChange: EventHandler<any>,
  id?: string
}

interface IEditorState {
}

class Editor extends React.Component<IEditorProps, IEditorState>
{
  constructor(props: IEditorProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="form-control" style={{ height: "auto" }}>
        <Ed id={this.props.id || "inputContent"} apiKey="9g0ulblxwkd76vrrs111j7ayxpx4tqqhkj1ai4nusl44j1zg"
          initialValue={this.props.initialValue}
          inline={true}
          onChange={this.props.onChange}
          init={{
            plugins: 'print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern help',
            toolbar: 'formatselect | bold italic strikethrough underline forecolor backcolor permanentpen formatpainter | link image media pageembed | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat | addcomment',
            image_advtab: true,
            language: 'fr_FR',
            spellchecker_language: 'fr_FR'
          }} />
      </div>
    );
  }

  onEditorChange(editorState: any) {
    this.setState({ editorState })
  }

}

export default Editor;
